import { CasButton, CasPage } from 'src/compass/shared/components';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';
import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';

import DashboardTab from './_claimTracking/components/DashboardTab';
import SearchTab from './_claimTracking/components/SearchTab';
import ActivityLogTab from './_claimTracking/components/ActivityLogTab';
import DataTab from './_claimTracking/components/DataTab';
import { ClaimOpenDialog } from './_claimTracking/components/ClaimOpenDialog';

import TodoTab, { TabListTodo } from './_claimTracking/todoTab/TodoTab';
import EntryTab from './_claimTracking/entryTab/EntryTab';
import SettingsTab from './_claimTracking/settingsTab/SettingsTab';

export const TabListClaimTracking = {
  noDefault: false,
  tabs: [
    { label: 'Dashboard', children: <DashboardTab /> },
    { label: 'Todo', children: <TodoTab />, nested: TabListTodo },
    { label: 'Entry', children: <EntryTab /> },
    { label: 'Search', children: <SearchTab /> },
    { label: 'Data', children: <DataTab /> },
    { label: 'Activity Log', children: <ActivityLogTab />, path: 'ActivityLog' },
    { label: 'Settings', children: <SettingsTab /> },
  ],
};

export default function ClaimTrackingPage() {
  const dialog = useCasBoolean();

  return (
    <CasPage
      title="Claim Tracking"
      pageTitle="Endorsements"
      pageActions={<CasButton onClick={dialog.setTrue}>Open</CasButton>}
    >
      <CasRouterTabs baseUrl="/endorsements/claimtracking" tabList={TabListClaimTracking.tabs} />

      {dialog.value && <ClaimOpenDialog open onClose={dialog.setFalse} />}
    </CasPage>
  );
}
